import styled, { css } from 'styled-components'
import { desktopBreakpoint, tabletBreakpoint, wideScreenBreakpoint } from 'react-components'
import DynamicMarkdown from '../../app-components/dynamic-components/dynamic-markdown'

export const Container = styled.section(
    () => css`
        padding: 0.5rem 1rem;
        display: flex;
        flex-direction: column;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: 2rem 1.5rem 1rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            flex-direction: row;
            padding: 2rem 1.5rem 1rem;
        }

        @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
            padding: 2rem 4rem 1rem;
        }
    `,
)

export const TitleSubtitleWrapper = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing.xxSmall};
        margin-bottom: 0;
        padding: ${theme.spacing.medium} 0 0;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            margin-bottom: ${theme.spacing.medium};
            padding: ${theme.spacing.small} 0 ${theme.spacing.xxSmall};
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            margin-right: 1.125rem;
            max-width: 15rem;
        }

        @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
            margin-right: 1.5rem;
            max-width: 17.625rem;
        }
    `,
)

export const ContentWrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`

export const FAQItem = styled.div(
    ({ theme }) => css`
        display: flex;
        flex-direction: column;
        gap: ${theme.spacing.xSmall};
        padding: ${theme.spacing.large} 0;
        border-bottom: 0.0625rem dotted #d3d3d3;
        text-decoration: none;
        color: inherit;

        &:first-child {
            padding-top: ${theme.spacing.medium};
        }

        &:last-child {
            padding-bottom: ${theme.spacing.medium};
            border-bottom: none;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            flex-direction: row;
            gap: ${theme.spacing.large};
        }
    `,
)

export const Question = styled.h3(
    ({ theme }) => css`
        display: flex;
        width: auto;
        max-width: none;
        font-family: ${theme.typography.font.family.lato};
        font-weight: 600;
        font-size: ${theme.typography.font.size.large};
        color: ${theme.colors.tfwBlack99};
        line-height: 1.75rem;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            max-width: none;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            width: auto;
            max-width: 16.25rem;
        }
    `,
)

export const CustomMarkdown = styled(DynamicMarkdown)(
    ({ theme }) => css`
        flex: 1;

        & ul,
        li {
            font: ${theme.typography.font.lato.weight.regular} ${theme.typography.font.size.medium} / 1.5rem
                ${theme.typography.font.family.lato};
            color: ${theme.colors.tfwBlack99};
            margin: ${theme.spacing.small} ${theme.spacing.medium};
            padding: 0;
        }

        & p,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6 {
            font: ${theme.typography.font.lato.weight.regular} ${theme.typography.font.size.medium} / 1.5rem
                ${theme.typography.font.family.lato};
            color: ${theme.colors.tfwBlack99};
            margin: ${theme.spacing.medium} 0;
            padding: 0;
        }

        & strong {
            color: #4a4a4a;
        }

        & p:first-child {
            margin-top: 0;
        }

        & p:last-child {
            margin-bottom: 0;
        }

        & a {
            color: #016bd4;
            text-decoration: none;

            &:hover {
                color: #0159b8;
                text-decoration: underline;
            }
        }
    `,
)
